import { defineStore } from 'pinia'
import localSave from '@utils/local-save'

export const useSettingsStore = defineStore('settings', {
    state: () => ({
        volume: localSave.get('volume') !== null ? localSave.get('volume') : 25,
        currentOnDemandQualityKey: localSave.get('currentOnDemandQualityKey') || 'low',
    }),
    actions: {
        setSettings({ volume, currentOnDemandQualityKey }) {
            if (volume !== undefined) {
                this.volume = volume
                localSave.save('volume', this.volume)
            }

            if (currentOnDemandQualityKey !== undefined) {
                this.currentOnDemandQualityKey = currentOnDemandQualityKey
            }
        },
    },
})
